module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex user-layout-wrapper",
    class: {
      'expanded': _vm.innerSidebarState, 'innersidebar-expanded': _vm.innerSidebar.length
    }
  }, [_c('v-sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main"
  }, [_c('v-header'), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [(_vm.alertWarning != '') ? _c('div', {
    staticClass: "account_alert"
  }, [_vm._v(_vm._s(_vm.alertWarning) + " "), _c('a', {
    staticClass: "alert-warning-link",
    attrs: {
      "href": "mailTo:support@kundan.no"
    }
  }, [_vm._v("support@kundan.no")])]) : _vm._e(), _vm._v(" "), (_vm.hasUnpaidInvoice) ? _c('div', {
    staticClass: "account_alert unpaid-invoice-alert"
  }, [_c('svg', {
    staticClass: "unpaid-invoice-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "40",
      "height": "40",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12.01",
      "y2": "8"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "unpaid-invoice-text"
  }, [_c('span', {
    staticClass: "unpaid-invoice-title"
  }, [_vm._v(_vm._s(_vm.$t('static.unpaidInvoiceAlert.title')))]), _vm._v(" "), _c('span', {
    staticClass: "unpaid-invoice-body"
  }, [_vm._v(_vm._s(_vm.$t('static.unpaidInvoiceAlert.body')) + " "), _c('a', {
    staticClass: "alert-warning-link",
    attrs: {
      "href": "mailTo:support@kundan.no"
    }
  }, [_vm._v("support@kundan.no")])])])]) : _vm._e(), _vm._v(" "), (_vm.bridgeHandoffMessage) ? _c('div', {
    staticClass: "account_alert bridge-handoff-alert",
    class: {
      'bridge-handoff-decommissioned': _vm.stockDecommissioned
    }
  }, [_vm._v("\n        " + _vm._s(_vm.bridgeHandoffMessage) + "\n        "), (_vm.inventoryAppUrl) ? _c('a', {
    staticClass: "alert-warning-link",
    attrs: {
      "href": _vm.inventoryAppUrl,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('static.bridgeHandoff.openApp')) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "footer-inner"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": require("../../../assets/images/kundan-logo-white.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-meta"
  }, [_c('span', {
    staticClass: "footer-copyright"
  }, [_vm._v("© " + _vm._s(new Date().getFullYear()) + " Kundan + AS. All rights reserved.")]), _vm._v(" "), _c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "mailto:support@kundan.no"
    }
  }, [_vm._v("support@kundan.no")])])])])], 2)], 1), _vm._v(" "), _c('v-dialog')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-514ffa78","hasScoped":false}!./src/app/layouts/user/user.html
// module id = 3009
// module chunks = 1